import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { PDFPreview } from "../../components/PDFPreview/PDFPreview";
import { updateCertificateTemplate } from "../../services/training-session.service";
import { useDispatch } from "react-redux";
import { showAlert } from "../../store/alertSlice";
import CertificateModal from "../../components/CertificateModal/CertificateModal";

export interface DropdownOption {
  id: number;
  name: string;
}

const PreviewPdf = () => {
  const [isPdfLoaded, setIsPdfLoaded] = useState<boolean>(false);
  const location = useLocation();
  const { certificateData, editedData } = location.state || {};
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSaveModal = async (title: string, orgType: DropdownOption) => {
    try {
      const payload: Record<string, any> = {
        certificateType: certificateData?.certificateType,
        parentId: certificateData?.parentId,
        organisationId: orgType?.id,
        meta: "{}",
        template: editedData,
        name: title,
      };

      const result = await updateCertificateTemplate(payload);

      if (result?.status === 200) {
        showAlertMessage("Successfully saved certificate", "success");
        navigate(`/certificate-listing`);
        return;
      }

      const errorMessage = result?.error?.message?.toLowerCase();
      if (errorMessage === "name already exists") {
        showAlertMessage("File name already exists", "error");
      } else {
        showAlertMessage("Failed to save certificate", "error");
      }
    } catch (error) {
      console.error("Error while updating certificate:", error);
    }
  };

  const showAlertMessage = (message: string, type: "success" | "error") => {
    dispatch(showAlert({ message, type }));
  };

  return (
    <>
      <PDFPreview
        html={editedData}
        onLoadStateChange={(v: boolean) => setIsPdfLoaded(v)}
        data-testid="pdf-preview"
      />

      {isPdfLoaded && (
        <div
          className="d-flex justify-content-center p-2"
          data-testid="certificate-modal-component"
        >
          <CertificateModal onSave={handleSaveModal} />
        </div>
      )}
    </>
  );
};

export default PreviewPdf;
